/* 
  ### Chart Default Data ### 
  Predefined component's behaviors for the Filter & Action
*/

import J2_Filter_Viewer           from '../Project_Trion/99_Migration/Filter_Viewer/index.vue'
import J2_P6_TABLE_EL             from '../Project_Trion/99_Migration/J2_Table_EL/index.vue'
import J2_P6_TREND_EL             from '../Project_Trion/99_Migration/J2_Trend_EL/index.vue'
import Tube                       from '../Project_Trion/99_Migration/Tube/index.vue'
 

// Homepage
import TR_HM_EPC_STATUS           from '../Project_Trion/Home/EPC_Status/index.vue'
import TR_HM_ERECTION             from '../Project_Trion/Home/Erection/index.vue'
import TR_HM_ERECTION2            from '../Project_Trion/Home/Erection2/index.vue'
import TR_HM_PYRAMID              from '../Project_Trion/Home/Pyramid/index.vue'
import TR_HM_COMMDITY             from '../Project_Trion/Home/Commodity/index.vue'
import TR_HM_PROGRESS             from '../Project_Trion/Home/Progress/index.vue'

// Planning
import TR_DP_MAN_OVERALL          from '../Project_Trion/Dashboard/Planning/Man_Overall/index.vue'
import TR_DP_MAN_DROPDOWN         from '../Project_Trion/Dashboard/Planning/Man_Dropdown/index.vue'
import TR_DP_MAN_DISC             from '../Project_Trion/Dashboard/Planning/Man_Discipline/index.vue'
import TR_DP_MAN_OVERALL_WEEK     from '../Project_Trion/Dashboard/Planning/Man_Overall_Week/index.vue'
import TR_DP_MAN_DROPDOWN_WEEK    from '../Project_Trion/Dashboard/Planning/Man_Dropdown_Week/index.vue'
import TR_DP_MAN_DISC_WEEK        from '../Project_Trion/Dashboard/Planning/Man_Discipline_Week/index.vue'
import TR_DP_MAN_OVERALL_MH       from '../Project_Trion/Dashboard/Planning/Man_Overall_MH/index.vue'
import TR_DP_MAN_DROPDOWN_MH      from '../Project_Trion/Dashboard/Planning/Man_Dropdown_MH/index.vue'
import TR_DP_MAN_DISC_MH          from '../Project_Trion/Dashboard/Planning/Man_Discipline_MH/index.vue'
import TR_DP_MAN_OVERALL_WEEK_MH  from '../Project_Trion/Dashboard/Planning/Man_Overall_Week_MH/index.vue'
import TR_DP_MAN_DROPDOWN_WEEK_MH from '../Project_Trion/Dashboard/Planning/Man_Dropdown_Week_MH/index.vue'
import TR_DP_MAN_DISC_WEEK_MH     from '../Project_Trion/Dashboard/Planning/Man_Discipline_Week_MH/index.vue'

// Construction
import TR_DC_DISCIPLINE_AREA      from '../Project_Trion/Dashboard/Construction/Discipline_Area/index.vue'
import TR_DC_DISCIPLINE_AREA_MONTH      from '../Project_Trion/Dashboard/Construction/Discipline_Area_Month/index.vue'
import TR_DC_STR_STAGE            from '../Project_Trion/Dashboard/Construction/STR_Stage/index.vue'
import TR_DC_STR_SCH              from '../Project_Trion/Dashboard/Construction/STR_Schedule/index.vue'
import TR_DC_PIP_AREA             from '../Project_Trion/Dashboard/Construction/PIP_Area/index.vue'
import TR_DC_PIP_TABLE            from '../Project_Trion/Dashboard/Construction/PIP_Table/index.vue'

// Engineering
import TR_DE_SHOP_OVERALL         from '../Project_Trion/Dashboard/Engineering/Shop_Overall/index.vue'
import TR_DE_SHOP_AREA            from '../Project_Trion/Dashboard/Engineering/Shop_Area/index.vue'

// System Completion
import TR_DS_MOST_PUNCH           from '../Project_Trion/Dashboard/SystemCompletion/Most_Punch/index.vue'
import TR_DS_MOST_ITRS            from '../Project_Trion/Dashboard/SystemCompletion/Most_ITRs/index.vue'
import TR_DS_SLIDE_PUNCH          from '../Project_Trion/Dashboard/SystemCompletion/Slide_Punch/index.vue'

import TR_SUBSYSTEM               from '../Project_Trion/SystemCompletion/SubSystem/index.vue'
import TR_SYSTEM                  from '../Project_Trion/SystemCompletion/System/index.vue'
import TR_STATUS_SHEETS           from '../Project_Trion/SystemCompletion/Status_Sheets/index.vue'
import TR_STATUS_SHEETS_SINGLE    from '../Project_Trion/SystemCompletion/Status_Sheets_Single/index.vue'
import TR_SKYLINE_MCC             from '../Project_Trion/SystemCompletion/Skyline_MCC/index.vue'
import TR_SKYLINE_PCC             from '../Project_Trion/SystemCompletion/Skyline_PCC/index.vue'
import TR_LOGIC_CHARTS            from '../Project_Trion/SystemCompletion/LogicCharts/index.vue'
import TR_RADIAL_MC               from '../Project_Trion/SystemCompletion/Radial_MC/index.vue'
import TR_RADIAL_PC               from '../Project_Trion/SystemCompletion/Radial_PC/index.vue'
import TR_SYSTEM_BOUNDARY         from '../Project_Trion/SystemCompletion/System_Boundary/index.vue'

// Safety
import TR_SFT_INJURY              from '../Project_Trion/Dashboard/Safety/Injury/index.vue'

// 3D Visualization
import TR_Erection_Network        from '../Project_Trion/Visualization/Erection_Network/index.vue'
import TR_Yard_Timeline           from '../Project_Trion/Visualization/Yard_Timeline/index.vue'
import TR_Block_Division          from '../Project_Trion/Visualization/Block_Division/index.vue'
import TR_Block_Division_r1       from '../Project_Trion/Visualization/Block_Division_r1/index.vue'
import TR_Layout_Equipment        from '../Project_Trion/Visualization/Layout_Equipment/index.vue'
import TR_Layout_Yard             from '../Project_Trion/Visualization/Layout_Yard/index.vue'
import TR_Layout_LQ               from '../Project_Trion/Visualization/Layout_LQ/index.vue'

// Custom Charts
import TR_SKYLINE_BLOCK           from '../Project_Trion/Skylines/Blocks/index.vue'
import TR_SKYLINE_RFQ             from '../Project_Trion/Skylines/RFQ/index.vue'
import TR_SKYLINE_RFQ_TAG         from '../Project_Trion/Skylines/RFQ_tag/index.vue'

import TR_SCURVE_ENG              from '../Project_Trion/CustomChart/SCurve_ENG/index.vue'
import TR_SCURVE_PRO              from '../Project_Trion/CustomChart/SCurve_PRO/index.vue'
import TR_SCURVE_CON              from '../Project_Trion/CustomChart/SCurve_CON/index.vue'
import TR_ERECTION_LIST           from '../Project_Trion/CustomChart/Erection_List/index.vue'
import TR_PROC_RFQ                from '../Project_Trion/Procurement/RFQ/index.vue'


// Modal
import TR_MW_SCH_AREA             from '../Project_Trion/ModalWindow/Schedule/Area/index.vue'
import TR_MW_SCH_ZONE             from '../Project_Trion/ModalWindow/Schedule/Zone/index.vue'
import TR_MW_SCH_EREC             from '../Project_Trion/ModalWindow/Schedule/Erection/index.vue'
import TR_MW_SCH_PE1              from '../Project_Trion/ModalWindow/Schedule/PE1/index.vue'
import TR_MW_SCH_BLOCK            from '../Project_Trion/ModalWindow/Schedule/Block/index.vue'

import TR_MW_OUT_AREA_SPOOL       from '../Project_Trion/ModalWindow/Outfitting/Area_Spool/index.vue'
import TR_MW_OUT_AREA_EQ          from '../Project_Trion/ModalWindow/Outfitting/Area_EQ/index.vue'
import TR_MW_OUT_OVERALL          from '../Project_Trion/ModalWindow/Outfitting/Overall_Disc/index.vue'


export default {

  J2_Filter_Viewer,
  J2_P6_TABLE_EL,
  J2_P6_TREND_EL,
  Tube,
  
  // Homepage
  TR_HM_EPC_STATUS,
  TR_HM_ERECTION,
  TR_HM_ERECTION2,
  TR_HM_PYRAMID,
  TR_HM_COMMDITY,
  TR_HM_PROGRESS,
  
  // Planning
  TR_DP_MAN_OVERALL,
  TR_DP_MAN_DROPDOWN,
  TR_DP_MAN_DISC,
  TR_DP_MAN_OVERALL_WEEK,
  TR_DP_MAN_DROPDOWN_WEEK,
  TR_DP_MAN_DISC_WEEK,
  TR_DP_MAN_OVERALL_MH,
  TR_DP_MAN_DROPDOWN_MH,
  TR_DP_MAN_DISC_MH,
  TR_DP_MAN_OVERALL_WEEK_MH,
  TR_DP_MAN_DROPDOWN_WEEK_MH,
  TR_DP_MAN_DISC_WEEK_MH,
  
  // Construction
  TR_DC_DISCIPLINE_AREA,
  TR_DC_DISCIPLINE_AREA_MONTH,
  TR_DC_STR_STAGE,
  TR_DC_STR_SCH,
  TR_DC_PIP_AREA,
  TR_DC_PIP_TABLE,

  // Engineering
  TR_DE_SHOP_OVERALL,
  TR_DE_SHOP_AREA,
  

  // Safety
  TR_SFT_INJURY,
  
  // System Completion
  TR_DS_MOST_PUNCH,
  TR_DS_SLIDE_PUNCH,
  TR_DS_MOST_ITRS,
  TR_SKYLINE_MCC,
  TR_SKYLINE_PCC,
  TR_LOGIC_CHARTS,
  TR_SUBSYSTEM,
  TR_SYSTEM,
  TR_STATUS_SHEETS,
  TR_STATUS_SHEETS_SINGLE,
  TR_RADIAL_MC,
  TR_RADIAL_PC,
  TR_SYSTEM_BOUNDARY,
  
  // 3D Visualization
  TR_Erection_Network,
  TR_Yard_Timeline,
  TR_Block_Division,
  TR_Block_Division_r1,
  TR_Layout_Equipment,
  TR_Layout_Yard,
  TR_Layout_LQ,

  // Custom Charts
  TR_SKYLINE_BLOCK,
  TR_SKYLINE_RFQ,
  TR_SKYLINE_RFQ_TAG,
  TR_SCURVE_ENG,
  TR_SCURVE_PRO,
  TR_SCURVE_CON,
  TR_ERECTION_LIST,
  TR_PROC_RFQ,


  // Modal
  TR_MW_SCH_AREA,
  TR_MW_SCH_ZONE,
  TR_MW_SCH_EREC,
  TR_MW_SCH_PE1,
  TR_MW_SCH_BLOCK,
  
  TR_MW_OUT_AREA_SPOOL,
  TR_MW_OUT_AREA_EQ,
  TR_MW_OUT_OVERALL,

}
